import { buildTwelveNoteScale } from "../data/twelveNoteScale";
import { Interval, IntervalToHalfStepsMap } from "../models/Intervals.model";
import { MusicNote, isSameMusicNote } from "../models/MusicNote.model";

export function findNoteByInterval({
  rootNote,
  interval,
  direction,
}: {
  rootNote: MusicNote;
  interval: Interval;
  direction: "above" | "below";
}): MusicNote {
  const twelveNoteScale = buildTwelveNoteScale();
  const startingIndex = twelveNoteScale.findIndex((note) => isSameMusicNote(note, rootNote));

  const halfSteps = IntervalToHalfStepsMap[interval] % 12;
  const upwardsHalfSteps = direction === "below" ? 12 - halfSteps : halfSteps;

  let targetIndex = (startingIndex + upwardsHalfSteps) % 12; // the +12 prevents negative indices
  return twelveNoteScale[targetIndex];
}
